import React from 'react';
import { List, ListProps } from '@mui/material';

export const Ul: React.FC<ListProps> = (props) => (
  <List disablePadding sx={{ listStyle: 'initial' }} {...props} />
);
